import { inject, Service } from '@angular/core';
import { LogInfoBuilder } from '@h5s/util-logger';
import { PwaUpdateDebug, PwaUpdateError, PwaUpdateInfo, PwaUpdateLoggerBase } from '@h5s/util-pwa';
import { FeatureLogService } from './feature-log.service';

@Service()
export class AppUpdateLoggerService extends PwaUpdateLoggerBase {
  private readonly featureLogService = inject(FeatureLogService);

  public override debug(message: string, debug: PwaUpdateDebug): void {
    super.debug(message, debug);

    const logInfo = new LogInfoBuilder(message);

    switch (debug.source) {
      case 'SW_DISABLED':
        logInfo.addInfo('swDisabled', true);
        break;

      case 'NO_NEW_VERSION_DETECTED':
        logInfo.addInfo('noNewVersionDetected', true);
        break;
    }

    this.featureLogService.debugExternal(logInfo.build());
  }

  public override info(message: string, info: PwaUpdateInfo): void {
    super.info(message, info);

    const logInfo = new LogInfoBuilder(message);

    switch (info.source) {
      case 'VERSION_DETECTED':
        logInfo.addInfo('version', info.version);
        break;

      case 'VERSION_READY':
        logInfo.addInfo('currentVersion', info.currentVersion).addInfo('latestVersion', info.latestVersion);
        break;

      case 'UPDATE_FOUND':
        logInfo.addInfo('updateFound', true);
        break;

      case 'UPDATE_NOT_FOUND':
        logInfo.addInfo('updateFound', false);
        break;
    }

    this.featureLogService.infoExternal(logInfo.build());
  }

  public override error(message: string, error: PwaUpdateError): void {
    super.error(message, error);

    const logInfo = new LogInfoBuilder(message);

    switch (error.source) {
      case 'VERSION_INSTALLATION_FAILED':
        logInfo.addInfo('version', error.version).addInfo('error', error.error);
        break;

      case 'CHECK_FAILED':
        logInfo.addInfo('error', JSON.stringify(error.error));
        break;

      case 'UNRECOVERABLE_STATE':
        logInfo.addInfo('reason', error.reason);
        break;
    }

    this.featureLogService.errorExternal(logInfo.build());
  }
}
